import { createPusherSocket } from 'shared/services/socket'

// Public per-user channel for real-time product-update notifications. Unlike the
// auth socket, no channelAuthorization is needed: the event carries no material
// content, it only nudges the client to refetch the auth-protected pending list.
const productUpdatesSocket = createPusherSocket({
  socketName: 'product_updates',
  appKey: process.env.REACT_APP_AUTH_PUSHER_APP_KEY,
  wsHost: process.env.REACT_APP_WS_HOST,
  wsPort: Number(process.env.REACT_APP_WS_PORT ?? 443)
})

export const subscribeToProductUpdatesChannel = productUpdatesSocket.subscribe
